export class Input {
  private downKeys = new Set<string>();

  private keydownHandler = (e: KeyboardEvent) => {
    this.downKeys.add(e.code);
    this.downKeys.add(e.key);
  };

  private keyupHandler = (e: KeyboardEvent) => {
    this.downKeys.delete(e.code);
    this.downKeys.delete(e.key);
  };

  private attached = false;

  attach(target: Window | Document = window): void {
    if (this.attached) return;
    target.addEventListener("keydown", this.keydownHandler as EventListener);
    target.addEventListener("keyup", this.keyupHandler as EventListener);
    this.attached = true;
  }

  detach(target: Window | Document = window): void {
    if (!this.attached) return;
    target.removeEventListener("keydown", this.keydownHandler as EventListener);
    target.removeEventListener("keyup", this.keyupHandler as EventListener);
    this.attached = false;
    this.downKeys.clear();
  }

  isKeyDown(code: string): boolean {
    return this.downKeys.has(code);
  }
}
